import API from "./axios";

/**
 * To-Do OUTSIDE PEOPLE — who does work outside the factory (a tailor, a
 * vendor, a job worker with no login). Every login may keep the list, like
 * the to-do list itself.
 *
 * Person: { id, name, mobile, place, notes, active, label ("Name, Place"),
 * openTasks, totalTasks, restored, createdByName, createdAt }.
 *
 * remove: deleted when on no task (data null), otherwise made inactive — the
 * tasks keep the name. Adding a name that was removed earlier brings that one
 * back (`restored`). The server's message says which.
 */
export const todoOutsidePartyApi = {
  list: (q, includeInactive = false) => API.get("/todo-outside-parties", {
    params: { q: q || undefined, includeInactive: includeInactive || undefined },
  }),
  /** { name, mobile, place, notes } — only the name is required. */
  create: (body) => API.post("/todo-outside-parties", body),
  update: (id, body) => API.put(`/todo-outside-parties/${id}`, body),
  remove: (id) => API.delete(`/todo-outside-parties/${id}`),
  activate: (id) => API.post(`/todo-outside-parties/${id}/activate`),
};

export default todoOutsidePartyApi;
